<template>
<div class="process-editor-top">
  <!-- <button @click="gatePageHandler" class="process-add">+</button> -->
<!--  <div class="slctWrap">
    <p><span>{{ fieldNameSet[0] }}</span> {{fieldNameSet[1]}}</p>
  </div>-->
  <div class="process-name">
    <p v-html="getTitle"></p>
    
    <button @click="titlChangeModal" v-if="editBtnView && !readOnly && !experimentFlag" class="btn_top">수정</button>
    <button class="btn_basic" :style="{background : editorLayoutClass == 'layout_type_4' ? 'blanchedalmond':'white'}" v-if="experimentFlag" @click="applyClass('layout_type_4')">공정도/실험입력값 분할보기</button>
    <button class="btn_basic" :style="{background : editorLayoutClass == 'layout_type_2' ? 'blanchedalmond':'white'}" v-if="experimentFlag" @click="applyClass('layout_type_2')">실험입력값만 보기</button>
    <button class="btn_basic" :style="{background : editorLayoutClass == 'layout_type_1' ? 'blanchedalmond':'white'}" v-if="experimentFlag" @click="applyClass('layout_type_1')">공정도만 보기</button>
  </div>
<!--  <button type="text" class="search-process" @click="searchPopupShow">{{
    $route.query.editorType == 'process' ? `공정도 검색하기` : '프로토콜 검색하기'
  }}</button>-->
  <UserInfomation :userName="userName" />
  <Preview :process-info="selectProcessInfo" 
    @setMethod="getChildMethods('preview', $event)"
    @preview-close="searchPopupShow"
  />
  <ProcessSearch :type="$route.query.editorType" 
    @setMethod="getChildMethods('search', $event)" 
    @select-process="selectProcess"
    @process-preview="previewClick"
  />
  <MakeProcess :active="titleChange" :Type="checkProjectType" @confirm="modifyTop" :Data="crntProtocol || ProcessInfo" @close="titleChange=false"></MakeProcess>
  <Loading :visible="loading" type="fixed"/>
</div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import CommNew from "@processEditor/CommNew";
  import ProcessFieldSelector from '../common/selects/FieldSelector.vue'
  import ProcessSearch from '../common/ProcessSearch.vue'
  import Preview from '../processEditor/Preview.vue'
  import UserInfomation from '../common/user/userInfo.vue'
  import MakeProcess from '@/components/modal/MakeProcess';
  import Loading from '@common/loading.vue'

  const ProcessEditor = createNamespacedHelpers('ProcessEditor');
  const Hub = createNamespacedHelpers('Hub');

  export default {
    name: 'process-top',
    components : {
      ProcessFieldSelector, 
      ProcessSearch,
      MakeProcess,
      Preview,
      UserInfomation,
      Loading,
    },
    mixins:[CommNew],
    props: {
      disabled: {
        type: Boolean,
        default(){ return false }
      },
      experimentFlag : {
        type : Boolean,
        default : false
      },
      readOnly : {
        type : Boolean,
        default : false
      },
    },
    data () {
      return {
        ProcessInfo: {},
        ProtocolInfo: [],
        crntProtocol: null,
        searchOpen: false,
        title : '',
        titleEng: '',
        userName: '',
        userDetailVisible: false,
        // templateVisivle: true,
        searchMethods: {},
        previewMethods: {},
        selectProcessInfo: {},
        fieldName: '',
        titleChange: false,
        editBtnView:true,
        loading:false,
      }
    },
    computed: {
      ...ProcessEditor.mapGetters(['getProcessDetail']),
      fieldNameSet() {
        let names = ['', ''];
        if(typeof this.fieldName !== 'string') return names;
        names = this.fieldName.split('>')
        if(names.length === 0) return names;
        return [names.shift(), names.join('>')]
      },
      checkProjectType() {
        return `${this.$route.query.editorType}|edit`
      },
      getTitle() {
        return `<span>${this.title.replace(/<p\>|<\/p\>/gi, '')}</span> <span>${this.titleEng.replace(/<p\>|<\/p\>/gi, '')}</span>`;
      },
      showTitleEdit() {
        let status = true;
        if(this.$route.query.editorType === 'protocol' && !this.crntProtocol) status = false;
        return status
      },
      editorLayoutClass() {
        return this.$store.getters["Hub/getEditorLayoutClass"];
      },
    },

    watch:{
      '$route.query'() {
        this.changeTitle() ; 
      } , 
      USER_INFO(value) {
        this.userName = value.name
      }
    },
    mounted () {
      this.initTop();
    } , 
    methods: {
      ...Hub.mapMutations(
          [
            "setEditorLayoutClass",
          ]
      ),
      applyClass(adjustClassName){
        this.setEditorLayoutClass(adjustClassName);
      },
      checkJSON(data){
        function parsing() {
          data = JSON.parse(data);
          if(typeof data === 'string') parsing();
        }
        parsing();
        return data;
      },
      async initTop() {
        this.loading = true;
        if( !this.$route.query.processId ) return;
        const ProcessInfo = await this.$wApi.process.detail(null, this.$route.query.processId);
        if( !this.$route.query.processId ) return;
        const Protocols = await this.$wApi.protocol.gets({
          processId: this.$route.query.processId,
          isMemo: false,
          isConent: false,
          isComment: false,
        });
        this.ProcessInfo = ProcessInfo;
        this.ProtocolInfo = [];
        for(let protocol of Protocols) {
          this.ProtocolInfo.push(protocol);
        }
        this.changeTitle();
        this.loading = false;
      },
      changeTitle () {
        this.loading = true;
        const { editorType } = this.$route.query ; 
        switch ( editorType ) {
          case 'process' : 
            if( this.ProcessInfo.processType == 'ONLY_PROTOCOL' ){
              const crntProtocol = this.ProtocolInfo[0] ; 
              this.editBtnView = false;
              this.title = crntProtocol.name || '';
              this.titleEng = '프로토콜 기본정보';
              this.fieldName = crntProtocol.fieldName;  
            }else{
              this.title = this.ProcessInfo.processName || '';
              this.titleEng = this.ProcessInfo.processEngName || '';
              this.fieldName = this.ProcessInfo.fieldName;  
            }
            break ; 
          case 'protocol' :
            const crntProtocol = this.ProtocolInfo.filter( p => p.id == this.$route.query.protocolId )[0] ;
            // console.log( "crntProtocol", crntProtocol )
            if ( !crntProtocol ) {
              // this.title = `프로토콜명 ${ this.crntDate }` ; 
              this.title = `비어있는 프로토콜` ; 
              this.titleEng = 'Empty protocol';
              this.fieldName = '';
              this.editBtnView = false;
            }else {
              this.title = crntProtocol.name || ''; 
              this.titleEng = crntProtocol.nameEng || '';
              this.fieldName = crntProtocol.fieldName || this.ProcessInfo.fieldName;
              this.crntProtocol = crntProtocol;
              this.crntProtocol.fieldId = this.crntProtocol.fieldId
              this.editBtnView = crntProtocol.editerMode == false ? false : true;
            }
          break ; 
        } ; 
        this.fieldNameSet;
        this.loading = false;
      } , 
      gatePageHandler () {
        this.$router.push({ path : `/${ this.$route.query.editorType }/gate` }) ; 
        // const { href } = this.$router.resolve({ 
        //   path : `/${ this.$route.query.editorType }/gate` , 
        // }) ; 
        // window.open( href , '_blank' ) ; 
      } , 
      getChildMethods(type, methods) {
        if(type === 'search') this.searchMethods = methods;
        else if(type === 'preview') this.previewMethods = methods;
      },
      searchPopupShow(){
        this.searchMethods.show();
      },
      selectProcess(item) {
        this.selectProcessInfo = item;
      },
      previewClick(item) {
        if(!this.selectProcessInfo) return;
        this.searchMethods.hide();
        this.previewMethods.show();
      },
      logout() {
        this.$store.commit('setState', ['user', null])
        localStorage.removeItem(
          process.env.VUE_APP_PROTOCOL
          ? "m3dHubEditor__token"
          : "kirinote__token"
        )
        this.$router.replace(
          // process.env.VUE_APP_PROTOCOL ? "/account/login" : "/account/login"
          '/'
        );
      },
      async modifyProcess(value) {
        this.loading = true;
        const { processId } = this.$route.query;
        const response = await this.$wApi.process.modify({
          fieldId: value.field[value.field.length-1],
          name: value.kr,
          nameEng: value.en,
          processType: this.PROCESS_INFO.processType,
          active: true,
          // 과학기술분류 
          knsccId: value.requestKnscc.knsccId,
          // 과학기술표준분류코드 
          knsccCode: value.requestKnscc.knsccCode,
          // 과학기술표준분류명 
          knsccCodeName: value.requestKnscc.knsccCodeName,
          // 대분류코드 
          categoryLargeCode: value.requestField.categoryLargeCode,
          // 대분류명 
          categoryLargeCodeName: value.requestField.categoryLargeCodeName,
          // 중분류코드 
          categoryMiddleCode: value.requestField.categoryMiddleCode,
          // 중분류명 
          categoryMiddleCodeName: value.requestField.categoryMiddleCodeName,
          // 소분류코드(공정식별번호) 
          categorySmallCode: value.requestField.categorySmallCode,
          // 소분류코드명 
          categorySmallCodeName: value.requestField.categorySmallCodeName,
          // 소소분류코드(하부공정식별번호) 
          categoryMicroCode: value.requestField.categoryMicroCode,
          // 소소분류코드명 
          categoryMicroCodeName: value.requestField.categoryMicroCodeName,
        }, processId ) ;
        this.titleChange = false;

        if(response) {
          this.title = response.name;
          this.titleEng = response.nameEng;  
          this.fieldName = response.fieldName;
          this.fieldNameSet;
        }
        //onlyProtocol의 경우 process update시 protocol도 함께 update
        const ProcessInfo = await this.$wApi.process.detail(null, processId);
        if (ProcessInfo.processType == "ONLY_PROTOCOL") {
          await this.$wApi.protocol.put({
            name: value.kr,
            nameEng: value.en,
            fieldId: value.field[value.field.length - 1],
            // 과학기술분류 
            knsccId: value.requestKnscc.knsccId,
            // 과학기술표준분류코드 
            knsccCode: value.requestKnscc.knsccCode,
            // 과학기술표준분류명 
            knsccCodeName: value.requestKnscc.knsccCodeName,
            // 대분류코드 
            categoryLargeCode: value.requestField.categoryLargeCode,
            // 대분류명 
            categoryLargeCodeName: value.requestField.categoryLargeCodeName,
            // 중분류코드 
            categoryMiddleCode: value.requestField.categoryMiddleCode,
            // 중분류명 
            categoryMiddleCodeName: value.requestField.categoryMiddleCodeName,
            // 소분류코드(공정식별번호) 
            categorySmallCode: value.requestField.categorySmallCode,
            // 소분류코드명 
            categorySmallCodeName: value.requestField.categorySmallCodeName,
            // 소소분류코드(하부공정식별번호) 
            categoryMicroCode: value.requestField.categoryMicroCode,
            // 소소분류코드명 
            categoryMicroCodeName: value.requestField.categoryMicroCodeName,
          }, this.crntProtocol.onlyProtocolProcessId);
        }
        this.loading = false;
      },
      async modifyProtocol(value) {
        this.loading = true;
        const { processId } = this.$route.query;
        const response = await this.$wApi.protocol.put({
          protocolId: this.crntProtocol.id,
          name: value.kr,
          nameEng: value.en,
          fieldId: value.field[value.field.length-1],
          protocolType: value.type,
          keyOfProtocol: this.crntProtocol.keyOfProtocol,
          content : this.crntProtocol.json,
          // 과학기술분류 
          knsccId: value.requestKnscc.knsccId,
          // 과학기술표준분류코드 
          knsccCode: value.requestKnscc.knsccCode,
          // 과학기술표준분류명 
          knsccCodeName: value.requestKnscc.knsccCodeName,
          // 대분류코드 
          categoryLargeCode: value.requestField.categoryLargeCode,
          // 대분류명 
          categoryLargeCodeName: value.requestField.categoryLargeCodeName,
          // 중분류코드 
          categoryMiddleCode: value.requestField.categoryMiddleCode,
          // 중분류명 
          categoryMiddleCodeName: value.requestField.categoryMiddleCodeName,
          // 소분류코드(공정식별번호) 
          categorySmallCode: value.requestField.categorySmallCode,
          // 소분류코드명 
          categorySmallCodeName: value.requestField.categorySmallCodeName,
          // 소소분류코드(하부공정식별번호) 
          categoryMicroCode: value.requestField.categoryMicroCode,
          // 소소분류코드명 
          categoryMicroCodeName: value.requestField.categoryMicroCodeName,
        }) ;
        this.titleChange = false;

        if(response && !response.error) {
          this.title = response.name;
          this.titleEng = response.nameEng;
          this.fieldName = response.fieldName;
          this.fieldNameSet;
        } else if(response.error && response.message){
          window.wToast(response.message, { variant: "red" });
        }
        //onlyProtocol의 경우 protocol update시 process도 함께 update
        const ProcessInfo = await this.$wApi.process.detail(null, this.crntProtocol.onlyProtocolProcessId);
        if (ProcessInfo.processType == "ONLY_PROTOCOL") {
          await this.$wApi.process.modify({
            fieldId: value.field[value.field.length - 1],
            name: value.kr,
            nameEng: value.en,
            // 과학기술분류 
            knsccId: value.requestKnscc.knsccId,
            // 과학기술표준분류코드 
            knsccCode: value.requestKnscc.knsccCode,
            // 과학기술표준분류명 
            knsccCodeName: value.requestKnscc.knsccCodeName,
            // 대분류코드 
            categoryLargeCode: value.requestField.categoryLargeCode,
            // 대분류명 
            categoryLargeCodeName: value.requestField.categoryLargeCodeName,
            // 중분류코드 
            categoryMiddleCode: value.requestField.categoryMiddleCode,
            // 중분류명 
            categoryMiddleCodeName: value.requestField.categoryMiddleCodeName,
            // 소분류코드(공정식별번호) 
            categorySmallCode: value.requestField.categorySmallCode,
            // 소분류코드명 
            categorySmallCodeName: value.requestField.categorySmallCodeName,
            // 소소분류코드(하부공정식별번호) 
            categoryMicroCode: value.requestField.categoryMicroCode,
            // 소소분류코드명 
            categoryMicroCodeName: value.requestField.categoryMicroCodeName,
          }, this.crntProtocol.onlyProtocolProcessId);
        }
        this.loading = false;
      },
      async modifyTop(value) {
        const {editorType} = this.$route.query;
        if(editorType === 'process') {
          await this.modifyProcess(value);
        } else {
          await this.modifyProtocol(value);
        }
        this.initTop();
        await this.status.issueListStatus.reload();
      },
      async titlChangeModal() {
/*      기술분류가 작성되지 않는 데이터가 존재함에 따라서 채번 완료 후 publicActive를 확인하도록 주석 해제 필요.
        // 클릭 시점에 공개 여부를 확인 후 공개시 수정이 불가능 하다는 알림을 띄움.
        const ProcessInfo = await this.$wApi.process.detail(null, this.$route.query.processId);
        if(ProcessInfo.publicActive != 0){
          let alertMsg = `<b>공개 완료된 ${this.$route.query.editorType == 'process' ? "공정도" : "프로토콜"}의 경우<br>"분류" 및 "기술분류" 수정이 불가능 합니다.</b>`;
          window.alert(alertMsg);
          this.titleChange = false;
        }else{*/
          this.titleChange = true;
/*        }*/
      }
    },
  }
</script>


<style lang="scss">
.process-name {
  > p {
    span {
      display: block;
      margin: 0 16px 0 0;
      font-size: 14px;
      &+span {
        margin: 4px 0 0;
        font-size: 12px; color: #999;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.process-editor-top {
  position: relative; z-index: 99; 
  display: flex; align-items: center;
  height: var( --process-editor-top-height );
  margin: 0 0 0 var( --default-gap );
  border-bottom: 1px solid #999;
  @include text-prt;

  > .slctWrap {
    display: flex; 
    justify-content: flex-end; align-items: center;
    width: 154px; height: 32px; 
    font-size: 12px; color: #666;
    span { 
      display: block;
      margin-bottom: 4px;
      font-size: 14px; color: #333;
    }
  }
  .process-add {
    display: inline-block;
    width: 32px; height: 32px; 
    border: 0;
    background: url('../../assets/icons/icon-home.svg') 0 0 no-repeat;
    background-size: cover;
    font-size: 0;
  }
  .process-name {
    display: flex;
    position: relative;
    flex-grow: 2;
    color: #333;
    font-weight: 600;
    border-left: 1px solid #999;
    padding-left: 16px; 
    margin-left: 16px;
    > p {
      span {
        display: block;
        font-size: 14px;
        &+span {
          margin: 4px 0 0;
          font-size: 12px; color: #999;
        }
      }
    }
    .btn_top {
      display: flex; align-items: center;
      border: 1px solid $dark-blue; border-radius: 5px;
      padding: 5px 8px;
      margin: 0 0 0 16px;
      color: $dark-blue;
      font-size: 12px; font-weight: 500;
      &:before {
        content:'';
        display: inline-block; width:12px; height: 12px;
        margin-right: 5px;
        background: url('@/assets/icons/icon-pencil.svg') center no-repeat;
      }
    }
  }
  .data-select { width: 200px; height: 24px;
    border-right: 1px solid #999;
    margin: 0 var( --default-gap ) 0 0;
    .data-input {
      justify-content: flex-end;
      text-align: right;
      font-size: var( --default-gap );
    }
    input {
      display: block;
      width: 100%; 
    }
  }
  .search-process {
    display: flex; 
    align-items: center; 
    border: 0;
    border-right: 1px solid #999;
    font-size: 16px;
    color: #999; 
    white-space: nowrap;
    &:active {
      background: none;
    }

    &::after {
      content: ''; 
      display: flex; 
      width: 24px; height: 24px; 
      background: url('../../assets/icons/magnify.svg') right 0px center no-repeat;
      margin-left: 8px; 
      margin-right: 24px; 
    }
    
  }

  .templatePopup {
    @include modalLayout('.templateList')
  }
}

</style>

